var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddEvent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.0304264,12.8674261 L21.5193953,6.37844955 C22.1167127,5.78113146 22.1167127,4.81269 21.5193953,4.21545737 C20.9220779,3.61813929 19.9537231,3.61813929 19.3564057,4.21545737 L12.8673513,10.7045194 L6.37829694,4.21537192 C5.78097956,3.61805383 4.81262468,3.61805383 4.2153073,4.21537192 C3.61807537,4.81269 3.61807537,5.78113146 4.2153073,6.37836409 L10.7043617,12.8673406 L4.2153073,19.3564026 C3.61807537,19.9537207 3.61807537,20.9221622 4.2153073,21.5193948 C4.81262468,22.1167129 5.78097956,22.1167129 6.37829694,21.5193948 L12.8673513,15.0303328 L19.3564057,21.5193948 C19.9536376,22.1167129 20.9220779,22.1167129 21.5193953,21.5193948 C22.1167127,20.9220767 22.1167127,19.9537207 21.5193953,19.3564026 L15.0304264,12.8674261 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icAddEvent",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(12.867383, 12.867383) rotate(-44.000000) translate(-12.867383, -12.867383) ",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddEvent);
export default __webpack_public_path__ + "static/media/icAddEvent.db0b5a638d1a9f3972e67ce0436d0623.svg";
export { ForwardRef as ReactComponent };